import PatientList from './PatientList';
import PatientDetail from './PatientDetail';
import PatientPage from './PatientPage';

export { PatientList, PatientDetail, PatientPage };
export default PatientPage;
